import { SharedModule } from 'src/app/shared/shared.module'

import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import * as fromOrganization from '../organization/organization.reducer'
import { OrganizationRelationEffects } from './organization-relation.effects'
import { OrganizationRoutingModule } from './organization-routing.module'
import { OrganizationEffects } from './organization.effects'
import { OrganizationSerializer } from './organization.serializer'
import { OrganizationService } from './organization.service'
import { RoleModule } from '../role/role.module'
import { MemberModule } from '../member/member.module'
import { UserRoleModule } from '../role/user-role/user-role.module'
import { OrganizationFormComponent } from './form/form.component'
import { OrganizationCreateModalComponent } from './create-modal/show.component'
import { CommonModule } from '@angular/common'
import { OrganizationRequiredSubscriptionService } from './organization-required-subscription.service'

@NgModule({
    imports: [
        CommonModule,
        OrganizationRoutingModule,
        SharedModule,
        RoleModule,
        UserRoleModule,
        MemberModule,
        StoreModule.forFeature(fromOrganization.FEATURE_NAME, fromOrganization.organizationReducer),
        EffectsModule.forFeature([OrganizationEffects, OrganizationRelationEffects])
    ],
    declarations: [OrganizationFormComponent, OrganizationCreateModalComponent],
    exports: [OrganizationCreateModalComponent, OrganizationFormComponent],
    providers: [
        OrganizationService,
        {
            provide: OrganizationSerializer,
            useClass: OrganizationSerializer
        },
        OrganizationRequiredSubscriptionService
    ]
})
export class OrganizationModule {}
